/**
 * 由 scripts/sync-field-ids.ts 生成，勿手改
 * 来源：lark-cli base +field-list（astro-genbox 模板 base）
 * 重新抓取：pnpm tsx packages/feishu-schema/scripts/sync-field-ids.ts
 */
export const FIELD_IDS = {
    brand_config: {
        table_id: 'tblnR8j9tQvYDdyP',
        fields: {
            Facebook: 'fld5x3US3E',
            Favicon: 'fldOsJyHog',
            'Hero 主图': 'fldvOhVC7n',
            Instagram: 'fld2HDasyz',
            LinkedIn: 'fldREE9lo5',
            Logo: 'fldCnAlQfI',
            'Meta 描述': 'fldQkNX3PY',
            'OG 图': 'fldbC6ZeMD',
            Slogan: 'fldOZxgRqF',
            TikTok: 'fldGS0TCZb',
            'USP 1': 'fldchwIFUM',
            'USP 2': 'fldA9DPHVj',
            'USP 3': 'fld1DrFRRP',
            'USP 4': 'fld0DgOYa8',
            WhatsApp: 'fldShCuNuj',
            'reCAPTCHA Secret Key': 'fldiKcWAb7',
            'reCAPTCHA Site Key': 'fldOqmDrSn',
            业务类型: 'fldImOhMDo',
            主色: 'fld16AWaHb',
            付款条件: 'fldP9DJivS',
            员工规模: 'fldkz0Yh2U',
            '品牌 slug': 'fldbfmK0Xb',
            品牌名: 'fldBTZmFhV',
            品牌故事简介: 'fldgzlsjeY',
            地址: 'fldfrtLtRc',
            官网域名: 'fldnuOWkyS',
            定位锚点: 'fldJ2c1kXa',
            成立年份: 'fldI5nREtc',
            支持语言: 'fldMzEwwxp',
            法律主体: 'fldTNl0XTw',
            物流方式: 'fldsm4Bcyq',
            状态: 'fld3D4Tljo',
            电话: 'fld2fdWfqD',
            目标市场: 'fldFB6Aqu2',
            行业类目: 'fldLSTYAhv',
            '询盘字段配置 JSON': 'fldlNobeoj',
            询盘接收邮箱: 'fldxoywmV1',
            询盘自动回复文案: 'fld0r4oLYR',
            贸易条款: 'fldx2Vrsjj',
            辅色: 'fldJ7WfBP2',
            邮箱: 'fldn9yMs4L',
        },
    },
    sku: {
        table_id: 'tblwpZtZZ8307k58',
        fields: {
            'HS Code': 'fldBZUbtwx',
            MOQ: 'fldduk0nGx',
            'MOQ 阶梯 JSON': 'fldYfKv9E3',
            'Meta 描述': 'fld6xaUb0n',
            'Meta 标题': 'fldASJcaCJ',
            'SKU 编号': 'fldGY0rkAR',
            中文产品名: 'fldlE3aHS7',
            产品图: 'fldfYfwaXr',
            关联品牌: 'fld5IzSAMK',
            包装说明: 'fld5Aav08W',
            卖点要点: 'fldq4i19gQ',
            含机铸工艺: 'fldA9AGNDO',
            品类标签: 'fldDJfklMI',
            定制选项: 'fld7GkPaof',
            尺寸: 'flda5RFBQh',
            是否精选: 'fldd9rR4Mt',
            显示顺序: 'fldGyE708n',
            最低价: 'fldlMcMUJa',
            最高价: 'flduwxsjQz',
            材质: 'fldYQPkBiw',
            状态: 'fldEBwNwkb',
            生产周期天: 'fldlYqx2qU',
            英文产品名: 'fldXRVMi7O',
            英文关键词: 'fldFwYiTfH',
            英文描述: 'fldrXpo7Gt',
            '视频 URL': 'fldyKIxP8p',
            详细描述: 'fld0oWU0xP',
            货币: 'fld242iFyG',
            运输重量kg: 'fldCVPyaVs',
            重量g: 'fldtVgV4YK',
        },
    },
    brand_content: {
        table_id: 'tbl5RGeNsy3ALIpw',
        fields: {
            关联品牌: 'fldDZS2X78',
            内容类型: 'fld2z2s7HM',
            标题: 'fldXpY4i8c',
            '正文 Markdown': 'fldyYX8XEa',
            状态: 'fldhRc4WI6',
            语言: 'fldwKrDOGN',
        },
    },
    deploy_config: {
        table_id: 'tbltLNAqLqqf6RLA',
        fields: {
            'Bing 验证': 'fldRtSKJzg',
            'Cloudflare 项目名': 'fldYlTrHzY',
            'DNS Zone ID': 'fldAZpofEQ',
            'DNS 服务商': 'fld5pPNvPb',
            'Facebook Pixel': 'fldK236zlq',
            'GA4 ID': 'fldiEpKjjn',
            'GSC 验证 TXT': 'fldVU5piPq',
            'Google Ads Tag': 'fldrf7qHS9',
            'Sitemap 配置': 'fld78fDZ0U',
            关联品牌: 'fldIvCvRR8',
            '品牌 slug': 'fldLHAnxWP',
            '已部署 URL': 'fldgXFfCFx',
            最近部署时间: 'fldIyGHn9s',
            部署状态: 'fldRIma0LL',
            重定向规则: 'fldYvrItfT',
        },
    },
    engine_config: {
        table_id: 'tbliBXu0KLVWhZrU',
        fields: {
            关联品牌: 'fldPU028av',
            '发布计划 Cron': 'fldiyDlliE',
            同步状态: 'fldBHvUvCs',
            '品牌 slug': 'fldQwD5hR4',
            '引擎 Workspace ID': 'fldkQnCyWC',
            文章分类: 'fldTLCXwRs',
            最近同步时间: 'fldZ2BZTui',
        },
    },
    certification: {
        table_id: 'tblOgfBIALbriNrp',
        fields: {
            关联品牌: 'fld6q2uqcu',
            显示顺序: 'fld2h4KHmw',
            状态: 'fldPbCOGg9',
            认证名称: 'fldMPXClpr',
            证书文件: 'fldngaZOOn',
            证书编号: 'fldZRkhk3d',
            过期日期: 'fld9iqjn2v',
            颁发日期: 'fldxO4FjfG',
            颁发机构: 'fldAAcNWil',
        },
    },
    testimonial: {
        table_id: 'tbloHwl4Lt0F3swq',
        fields: {
            关联品牌: 'fldt9mlY22',
            客户公司: 'fldtDOllCp',
            客户国家: 'fldATsZ7Qw',
            客户姓名: 'fld8UQvZ8K',
            客户照片: 'fldtdpS7vV',
            客户职位: 'fld0jesheW',
            是否精选: 'fldr8oSUUm',
            显示顺序: 'fldORIqYOq',
            来源: 'fldeo9i1TA',
            状态: 'fldDr8BD0W',
            证言正文: 'fldNHnqiEQ',
            评分: 'flddLxpqgm',
        },
    },
    exhibition: {
        table_id: 'tblMFet6kFhFuXtg',
        fields: {
            举办地点: 'fld067Nutj',
            关联品牌: 'fldVoCI8oa',
            展会名称: 'fldOe3dNBX',
            展会简介: 'fldEttR9od',
            展位号: 'fldhgg747J',
            年份: 'fldzT0GB2R',
            是否精选: 'fldnoXNJLE',
            显示顺序: 'fldKlrOD3O',
            月份: 'fldY8chdMz',
            状态: 'fldlJyt2oO',
            现场照片: 'fldDmbmN8Y',
        },
    },
};
//# sourceMappingURL=field-ids.generated.js.map